
"use client";

import AutoScroll from "embla-carousel-auto-scroll";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import cabotsLogo from "@/assets/logos/cabots.png";
import portersLogo from "@/assets/logos/porters-paints.png";
import duluxLogo from "@/assets/logos/dulux.png";
import haymesLogo from "@/assets/logos/haymes.png";
import cutekLogo from "@/assets/logos/cutek.png";
import taubmansLogo from "@/assets/logos/taubmans.png";

interface Logo {
  id: string;
  description: string;
  image: string;
  className?: string;
}

interface Logos3Props {
  heading?: string;
  logos?: Logo[];
  className?: string;
}

const Logos3 = ({
  heading = "Match top brand costs",
  logos = [{
    id: "logo-1",
    description: "Cabot's",
    image: cabotsLogo,
    className: "h-8 sm:h-10 w-auto"
  }, {
    id: "logo-2",
    description: "Porter's Original Paints",
    image: portersLogo,
    className: "h-12 w-auto"
  }, {
    id: "logo-3",
    description: "Dulux",
    image: duluxLogo,
    className: "h-8 sm:h-10 w-auto"
  }, {
    id: "logo-4",
    description: "Haymes Paint",
    image: haymesLogo,
    className: "h-10 w-auto"
  }, {
    id: "logo-5",
    description: "CUTEK",
    image: cutekLogo,
    className: "h-4 sm:h-6 w-auto"
  }, {
    id: "logo-6",
    description: "Taubmans",
    image: taubmansLogo,
    className: "h-4 sm:h-6 w-auto"
  }, {
    id: "logo-7",
    description: "Sikkens",
    image: "/lovable-uploads/01ca07c3-8353-495f-a980-03600d792123.png",
    className: "h-10 w-auto"
  }]
}: Logos3Props) => {
  return <section className="py-0">
      <div className="container flex flex-col items-center text-center">
        <h2 className="my-6 text-pretty font-display text-3xl text-quickatoo-charcoal lg:text-4xl">
          {heading}
        </h2>
      </div>
      <div className="p-5">
        <div className="relative mx-auto flex items-center justify-center lg:max-w-5xl">
          <Carousel opts={{
            loop: true,
            align: "center",
          }} plugins={[AutoScroll({
            playOnInit: true,
            speed: 0.7
          })]}>
            <CarouselContent className="ml-0">
              {logos.map(logo => <CarouselItem key={logo.id} className="flex basis-[40%] justify-center pl-0 sm:basis-1/4 md:basis-1/5 lg:basis-1/6">
                  <div className="flex shrink-0 items-center justify-center mx-5 sm:mx-8 lg:mx-12">
                    <div>
                      <img src={logo.image} alt={logo.description} className={logo.className} />
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>
          <div className="absolute inset-y-0 left-0 w-16 sm:w-12 bg-gradient-to-r from-background via-background to-transparent"></div>
          <div className="absolute inset-y-0 right-0 w-16 sm:w-12 bg-gradient-to-l from-background via-background to-transparent"></div>
        </div>
      </div>
    </section>;
};

export { Logos3 };
